import { TUserProfile } from '~/store/user/user.type';

export enum TOneClubGetUserTokenCode {
  success = 'SUCCESS',
  failure = 'Failure',
}

export enum TOneClubGetUserTokenData {
  PASSWORD = 'Password is not correct',
  USER = 'User is not exist',
  unknown = 'unknown',
}

export type TOneClubGetUserTokenResponse = {
  code: TOneClubGetUserTokenCode;
  jwt?: string;
  data?: TOneClubGetUserTokenData;
};

export type TOneClubGetUserTokenPayload = {
  username: string;
  password: string;
  from: 'Nani';
};

export type TOneClubGetUserProfileResponse = TUserProfile;

export type TOneClubGetUserProfilePayload = {
  jwt: string;
};
